import React from "react"
//import { Link } from "gatsby"

import * as styles from "./CompBlockCols.module.css"


const CompBlockCols = (props) => {

  return (

    <div className={`${styles.CompBlockCols}`}>
        {props.children}
    </div>

  )
}

export default CompBlockCols